/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import React, { useRef, useEffect } from 'react'
import { useGLTF, useAnimations } from '@react-three/drei'
import * as THREE from "three";


export default function Model({ ...props }) {
  const group = useRef()
  const { nodes, materials, animations } = useGLTF('./models/pablo.glb')
  const { actions } = useAnimations(animations, group)

  useEffect(() => {
    let animate = actions['Armature|mixamo.com|Layer0']
    animate.loop = THREE.LoopOnce;
    animate.clampWhenFinished = true;
    props.setAnimate(animate)
  }, [])

  return (
    <group ref={group} {...props} dispose={null}>
      <group name="Scene">
        <group name="Armature" rotation={[Math.PI / 2, 0, 0]} scale={0.01}>
          <primitive object={nodes.mixamorigHips} />
          <group name="cloth001">
            <skinnedMesh castShadow name="Mesh002" geometry={nodes.Mesh002.geometry} material={materials['cloth_MAT.003']} skeleton={nodes.Mesh002.skeleton} />
            <skinnedMesh castShadow name="Mesh002_1" geometry={nodes.Mesh002_1.geometry} material={materials['pants_MAT.003']} skeleton={nodes.Mesh002_1.skeleton} />
          </group>
          <skinnedMesh castShadow name="eyes001" geometry={nodes.eyes001.geometry} material={materials['eyes_MAT.002']} skeleton={nodes.eyes001.skeleton} />
          <skinnedMesh castShadow name="hair001" geometry={nodes.hair001.geometry} material={materials['hair_MAT.003']} skeleton={nodes.hair001.skeleton} />
          <skinnedMesh castShadow name="tongue001" geometry={nodes.tongue001.geometry} material={materials['tooth_MAT.001']} skeleton={nodes.tongue001.skeleton} />
          <group name="body001">
            <skinnedMesh castShadow name="Mesh001" geometry={nodes.Mesh001.geometry} material={materials['head_MAT.003']} skeleton={nodes.Mesh001.skeleton} morphTargetDictionary={nodes.Mesh001.morphTargetDictionary} morphTargetInfluences={nodes.Mesh001.morphTargetInfluences} />
            <skinnedMesh castShadow name="Mesh001_1" geometry={nodes.Mesh001_1.geometry} material={materials['body_MAT.003']} skeleton={nodes.Mesh001_1.skeleton} morphTargetDictionary={nodes.Mesh001_1.morphTargetDictionary} morphTargetInfluences={nodes.Mesh001_1.morphTargetInfluences} />
            <skinnedMesh castShadow name="Mesh001_2" geometry={nodes.Mesh001_2.geometry} material={materials['hair_MAT.003']} skeleton={nodes.Mesh001_2.skeleton} morphTargetDictionary={nodes.Mesh001_2.morphTargetDictionary} morphTargetInfluences={nodes.Mesh001_2.morphTargetInfluences} />
            <skinnedMesh castShadow name="Mesh001_3" geometry={nodes.Mesh001_3.geometry} material={materials['tooth_MAT.003']} skeleton={nodes.Mesh001_3.skeleton} morphTargetDictionary={nodes.Mesh001_3.morphTargetDictionary} morphTargetInfluences={nodes.Mesh001_3.morphTargetInfluences} />
          </group>
        </group>
      </group>
    </group>
  )
}

useGLTF.preload('/pablo.glb')
